<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.wageGroupNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.wageGroupName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="wageGroupNumber" label="编码" width="140" />
      <el-table-column prop="wageGroupName" label="名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="laborHourlyCost" label="人工小时费率" width="130" align="right" />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.wageGroupId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.wageGroupId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.wageGroupId ? '修改工资组' : '新增工资组'" :visible.sync="visible" width="520px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="编码" prop="wageGroupNumber">
          <el-input v-model="form.wageGroupNumber" />
        </el-form-item>
        <el-form-item label="名称" prop="wageGroupName">
          <el-input v-model="form.wageGroupName" />
        </el-form-item>
        <el-form-item label="人工小时费率">
          <el-input-number v-model="form.laborHourlyCost" :min="0" :precision="2" style="width:100%" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listWageGroup, getWageGroup, saveWageGroup, updateWageGroup, deleteWageGroup
} from '../../api/wageGroup'

function emptyForm() {
  return {
    wageGroupId: '',
    wageGroupNumber: '',
    wageGroupName: '',
    laborHourlyCost: 0,
    active: '1'
  }
}

export default {
  name: 'MesWageGroupPage',
  components: { ListPagination },
  data() {
    return {
      query: { wageGroupNumber: '', wageGroupName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      rules: {
        wageGroupNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        wageGroupName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listWageGroup({
        currentPage: this.page,
        pageSize: this.pageSize,
        wageGroupNumber: this.query.wageGroupNumber,
        wageGroupName: this.query.wageGroupName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getWageGroup(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = Object.assign({}, this.form)
        const req = payload.wageGroupId ? updateWageGroup(payload) : saveWageGroup(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.wageGroupId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteWageGroup(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
